export const SET_ERROR = 'APP/ERRORS/SET_ERROR'
export const REMOVE_ERROR = 'APP/ERRORS/REMOVE_ERROR'
export const SET_MESSAGE = 'APP/ERRORS/SET_MESSAGE'
